import List from "components/Admin/Configurations/ChartColor/List/List"
import React from "react"

const ListPage = () => {
    return (
        <React.Fragment>
            <List />
        </React.Fragment>
    )
}
export default ListPage
